<template>
    <div class="workModeDialog">
        <div class="xzy_dtms">
          {{ modeTitle }}
          <img class="gbdt_ms" src="../images/gbdt_ms.png" @click="close" alt="">
        </div>
        <div v-if="modeDialogType == 1" class="gglx_zhz">
          <div class="gglx_lxcs" @click="practiceClick">
            <div style="margin-top: 8px;" class="sectionCon">练习次数  <img src="../images/homework/icon-line.png" alt=""></div>
            <div style="margin-top: 4px;font-size: 18px;font-weight: 600;">{{ exerciseData.count || 0 }}</div>
          </div>
          <div class="gglx_jpg">
            <div class="gglx_jgsa"><div style="margin-top: 8px;">及格次数</div><div class="gglx_fs">{{ exerciseData.passNum || 0 }}</div></div>
            <div class="gglx_jgsa"><div style="margin-top: 8px;">平均分数</div><div class="gglx_fs">{{ exerciseData.average || 0 }}</div></div>
            <div class="gglx_jgsa"><div style="margin-top: 8px;">最高分数</div><div class="gglx_fs">{{ exerciseData.maxScore || 0 }}</div></div>
          </div>
        </div>
        <div class="xzksms_kszt">
          <div style="margin-right: 12px;" :class="ksms == 2 ? 'xzksms_ks':'xzksms_ksxz'" @click="xuanzest(1)">
            <div style="margin-left: 16px;">
              <img class="ksmo_ks" src="../images/kaishims.png" alt="">
              <div class="ksms_wz">考试模式</div>
              <div class="ksmo_jx">提交试卷后显示成绩与解析<span v-if="modeDialogType == 1">（简答不计分）</span></div>
            </div>
            <div class="ksmo_xzan"><el-radio v-model="ksms" :label="1"></el-radio></div>
          </div>
          <div :class="ksms == 1 ? 'xzksms_ks':'xzksms_ksxz'" @click="xuanzest(2)">
            <div style="margin-left: 16px;">
              <img class="ksmo_ks" src="../images/zhutims.png" alt="">
              <div class="ksms_wz">逐题模式</div>
              <div class="ksmo_jx">每答完一题立即显示答案和解析<span v-if="modeDialogType == 1">（简答不计分）</span></div>
            </div>
            <div class="ksmo_xzan"><el-radio v-model="ksms" :label="2"></el-radio></div>
          </div>
        </div>
        <div class="xzksms_xzy" @click="selectMode">写作业</div>
        <div style="height: 24px;"></div>
    </div>
</template>

<script>
export default {
    name: 'workModeDialog',
    props: {
        exerciseData: {
            type: Object,
            default: () => ({})
        },
        modeDialogType: {
            type: Number,
            default: 1 // 1：巩固练习，2：答题模式
        },
    },
    data() {
        return {
            ksms: 1,
        }
    },
    computed: {
        modeTitle() {
            return this.modeDialogType === 1 ? '巩固练习' : '答题模式'
        }
    },
    methods: {
        xuanzest(item) {
            this.ksms = item
        },
        practiceClick() {
            this.$emit('practiceClick')
        },
        selectMode() {
            this.$emit('selectMode', this.ksms)
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
.xzy_dtms {
    text-align: center;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-600;
    font-weight: 600;
    color: #202020;
    padding-top: 24px;
    .gbdt_ms {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 24px;
        cursor: pointer;
    }
}
.xzksms_kszt {
    display: flex;
    margin: 0 auto;
    width: 672px;
    margin-top: 24px;
    .xzksms_ksxz {
    width: 330px;
    height: 110px;
    background: #eaf1ff;
    border: 1px solid #286bff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    .ksmo_xzan {
        margin-top: 19px;
        margin-right: 17px;
    }
    .ksmo_jx {
        font-size: 13px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #848586;
        margin-top: 8px;
    }
    .ksms_wz {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #202020;
        margin-top: 4px;
    }
    .ksmo_ks {
        width: 24px;
        height: 24px;
        margin-top: 16px;
    }
    ::v-deep  .el-radio__inner {
        width: 18px;
        height: 18px;
        border-radius: 50%;
    }
    ::v-deep .el-radio__input.is-checked .el-radio__inner {
        width: 18px;
        height: 18px;
        border-radius: 50%;
    }
    ::v-deep .el-radio__input.is-checked .el-radio__inner::after {
        transform: translate(-50%, -50%) scale(1);
        content: "";
        width: 9px;
        height: 4px;
        border: 2px solid #fff;
        border-top: transparent;
        border-right: transparent;
        text-align: center;
        display: block;
        position: absolute;
        top: 4.5px;
        left: 3px;
        vertical-align: middle;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        border-radius: 0;
        background: none;
    }
    ::v-deep .el-radio__label  {
        display: none;
    }
    }
    .xzksms_ks {
        width: 330px;
        height: 110px;
        border: 1px solid #f0f4f5;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        .ksmo_xzan {
            margin-top: 19px;
            margin-right: 17px;
        }
        .ksmo_jx {
            font-size: 13px;
            font-family: PingFang SC, PingFang SC-400;
            font-weight: 400;
            color: #848586;
            margin-top: 8px;
        }
        .ksms_wz {
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-400;
            font-weight: 400;
            color: #202020;
            margin-top: 4px;
        }
        .ksmo_ks {
            width: 24px;
            height: 24px;
            margin-top: 16px;
        }
        ::v-deep  .el-radio__inner {
            width: 18px;
            height: 18px;
            border-radius: 50%;
        }
        ::v-deep .el-radio__input.is-checked .el-radio__inner {
            width: 18px;
            height: 18px;
            border-radius: 50%;
        }
        ::v-deep .el-radio__input.is-checked .el-radio__inner::after {
            transform: translate(-50%, -50%) scale(1);
            content: "";
            width: 9px;
            height: 4px;
            border: 2px solid #fff;
            border-top: transparent;
            border-right: transparent;
            text-align: center;
            display: block;
            position: absolute;
            top: 4.5px;
            left: 3px;
            vertical-align: middle;
            -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg);
            border-radius: 0;
            background: none;
        }
        ::v-deep .el-radio__label  {
            display: none;
        }
    }
}
.xzy_dtms {
    text-align: center;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-600;
    font-weight: 600;
    color: #202020;
    padding-top: 24px;
    .gbdt_ms {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 24px;
    }
}
.gglx_zhz {
    display: flex;
    margin: 0 auto;
    width: 672px;
    height: 65px;
    margin-top: 24px;
    .gglx_jpg {
        display: flex;
        width: 556px;
        height: 65px;
        background: #f4f6f6;
        border-radius: 8px;
        .gglx_jgsa {
            width: 185px;
            height: 65px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-400;
            font-weight: 400;
            text-align: center;
            color: #848586;
            .gglx_fs {
            margin-top: 4px;
            font-size: 18px;
            font-weight: 600;
            color: #202020;
            }
        }
    }
    .gglx_lxcs {
        width: 104px;
        height: 65px;
        background: #eaf1ff;
        border-radius: 8px;
        text-align: center;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #286bff;
        margin-right: 12px;
        cursor: pointer;
        .sectionCon {
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: 16px;
                height: 16px;
            }
        }
    }
}
.xzksms_xzy {
    width: 200px;
    height: 32px;
    background: #286bff;
    border-radius: 8px;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    color: #ffffff;
    margin: 0 auto;
    margin-top: 24px;
    cursor: pointer;
    user-select: none;
}
</style>